<script>
    import {createEventDispatcher} from "svelte/internal";
    import {now, getTimeDiffAsShortText, toDate} from "../../../../../lib/dates_times.js";
    import {prettyHTMLFromPlainText} from "../../../../../lib/utils";
    import {filemanager} from "../stores/misc";
    import {showLightBox} from "../stores/misc";
    import FileAttachmentList from "./FileAttachmentList.svelte";

    const dispatch = createEventDispatcher();

    export let type;
    export let owner_id;
    export let note;

    let is_editing = false;
    let are_you_sure = false;
    let show_audio = false;

    let edited_note_text = note.text;
    let files = note['files'] === undefined ? [] : note.files;

    const handleSaveNote = async () => {
        const url = `/api/${type}/${owner_id}/note/${note.id}`;
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                text: edited_note_text,
                files: files
            })
        });
        let result = await response.json();
        // console.log(response, result);
        // TODO check for errors before proceeding
        note = result;
        is_editing = !is_editing;
    };

    const handleDeleteNote = () => {
        if(!are_you_sure) {
            are_you_sure = true;
            setTimeout(() => are_you_sure = false, 4000); // 4 seconds to decide before it resets
        }
        else {
            dispatch('noteDeleteClicked', {id: note.id});
            are_you_sure = false;
        }
    };

    const handleCancelEditing = () => {
        edited_note_text = note.text;
        files = note['files'] === undefined ? [] : note.files;
        is_editing = !is_editing;
    };


    let is_uploading_files = false;
    const doChooseFile = () => {
        filemanager.chooseFiles();
        is_uploading_files = true;
    };

    $: {
        if(is_uploading_files) {
            if($filemanager.files.length > 0) {
                files = files.concat($filemanager.files);
                is_uploading_files = false;
                filemanager.resetFiles();
                console.log('files added, full list =', files);
            }
        }
    }
</script>

{#if !is_editing}
    <div class="flex space-x-3">
<!--        <div class="flex-shrink-0">-->
<!--            <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80" alt="">-->
<!--            <div class="h-10 w-10 rounded-full bg-orange-600" />-->
<!--        </div>-->
        <div class="grow">
            <!--                                                    <div class="text-sm">-->
            <!--                                                        <a href="#" class="font-medium text-gray-900">Leslie Alexander</a>-->
            <!--                                                    </div>-->
            <div class="mt-1 text-gray-700">
                {#if show_audio && note["audio_filename"] !== undefined}
                    <audio class="mb-2" controls preload="none" src="/api/voicenote/{note.audio_filename}"></audio>
                {/if}
                <p class="my-4 leading-relaxed">
                    {#if note["audio_filename"] !== undefined}
                        <span on:click={() => show_audio = !show_audio}
                              class="inline-flex px-1 py-1 mr-1 items-center rounded-md border border-gray-300 bg-white shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">
                            <svg viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-gray-200 fill-gray-200">
<!--                                <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />-->
<!--                                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clip-rule="evenodd" />-->
<!--                                <path fill-rule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clip-rule="evenodd" />                           </svg>-->
                                <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06zM18.584 5.106a.75.75 0 011.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 11-1.06-1.06 8.25 8.25 0 000-11.668.75.75 0 010-1.06z" />
                                <path d="M15.932 7.757a.75.75 0 011.061 0 6 6 0 010 8.486.75.75 0 01-1.06-1.061 4.5 4.5 0 000-6.364.75.75 0 010-1.06z" />
                            </svg>
                        </span>
                    {/if}
                    {@html prettyHTMLFromPlainText(note.text)}
                </p>
            </div>
            {#if note['files'] !== undefined && (note.files.length > 0 || $filemanager.is_uploading)}
                <div class="my-4">
                    {#if is_editing && $filemanager.is_uploading}
                        <div class="flex items-center justify-center rounded-md border border-transparent bg-orange-600 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        ><svg class="animate-spin self-center w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                        </svg>
                            Sending..</div>
                    {/if}
                    <FileAttachmentList files={note.files}></FileAttachmentList>
                </div>
            {/if}
            <div class="mt-2 space-x-2 text-sm flex justify-between">
                <div>
                    <button on:click={() => is_editing = !is_editing}
                            type="button" class="inline-flex align-text-bottom mr-4 font-medium text-gray-200">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="self-center w-4 h-4">
                            <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z" />
                        </svg>
                    </button>

                    {#if note['updated'] !== undefined}
                        <time class="text-gray-300" datetime="{note.updated}" title="{note.updated}">Updated {getTimeDiffAsShortText(now().valueOf() - toDate(note.updated))}</time>
                    {:else}
                        <time class="text-gray-300" datetime="{note.created}" title="{note.created}">{getTimeDiffAsShortText(now().valueOf() - toDate(note.created))}</time>
                    {/if}
                </div>
                <!-- space -->
                {#if are_you_sure}
                <button type="button" on:click={handleDeleteNote} class="px-4 font-medium text-red-400 animate-bounce">Sure? Tap again to delete</button>
                {:else}
                <button type="button" on:click={handleDeleteNote} class="inline-flex align-text-bottom px-2 font-medium text-gray-300">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="self-center w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                    </svg>
                </button>
                {/if}
            </div>
        </div>
    </div>
{:else}
    <!-- Editing -->
    <div class="bg-gray-50 px-4 py-6 sm:px-6">
        <div class="min-w-0 flex-1">
            <form class="relative">
                <div class="overflow-hidden bg-white rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-indigo-600">
                    <label for="comment" class="sr-only">Add a note</label>
                    <textarea bind:value={edited_note_text} rows="3" name="comment" id="comment" class="block w-full resize-none border-0 bg-transparent text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:py-1.5 sm:text-sm sm:leading-6" placeholder="Add a note..."></textarea>

                    <!-- Spacer element to match the height of the toolbar -->
                    <div class="py-2" aria-hidden="true">
                        <!-- Matches height of button in toolbar (1px border + 36px content height) -->
                        <div class="py-px">
                            <div class="h-9"></div>
                        </div>
                    </div>
                </div>

                <div class="absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2">
                    <div class="flex items-center space-x-5">
                        <div class="flex items-center">
                            <button on:click={doChooseFile} type="button" class="-m-2.5 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500">
                                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd" />
                                </svg>
                                <span class="sr-only">Attach a file</span>
                            </button>
                        </div>
                    </div>

                    <div class="flex flex-shrink-0 items-center space-x-2">
                        <button on:click|preventDefault={handleCancelEditing} type="submit" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">Cancel</button>
                        <button on:click|preventDefault={handleSaveNote} type="submit" class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Post</button>
                    </div>
                </div>
            </form>
        </div>

        {#if files.length > 0}
            <div class="my-4">
                <FileAttachmentList files={files}></FileAttachmentList>
            </div>
        {/if}
    </div>


<!--    <div class="bg-gray-50 px-4 py-6 sm:px-6">-->
<!--        <div class="flex space-x-3">-->
<!--            <div class="flex-shrink-0">-->
<!--                <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=8&amp;w=256&amp;h=256&amp;q=80" alt="">-->
<!--                <div class="h-10 w-10 rounded-full bg-orange-600"></div>-->
<!--            </div>-->
<!--            <div class="min-w-0 flex-1">-->
<!--                <form>-->
<!--                    <div>-->
<!--                        <label for="comment" class="sr-only">About</label>-->
<!--                        <textarea bind:value={edited_note_text} id="comment" name="comment" rows="3" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Add a note"></textarea>-->
<!--                    </div>-->
<!--                    <div class="mt-3 flex items-center justify-end">-->
<!--                                                                            <a href="#" class="group inline-flex items-start space-x-2 text-sm text-gray-500 hover:text-gray-900">-->
<!--                                                                                <svg class="h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500" x-description="Heroicon name: mini/question-mark-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
<!--                                                                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path>-->
<!--                                                                                </svg>-->
<!--                                                                                <span>Some HTML is okay.</span>-->
<!--                                                                            </a>-->

<!--                        <button on:click|preventDefault={handleCancelEditing}-->
<!--                                type="button"-->
<!--                                class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"-->
<!--                        >Cancel</button>-->
<!--                        <button on:click|preventDefault={handleSaveNote}-->
<!--                                type="submit"-->
<!--                                class="ml-3 inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"-->
<!--                        >Save Note</button>-->
<!--                    </div>-->
<!--                </form>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
{/if}



<style></style>